import type { Package } from "../types";
import { formatCents } from "../utils/format";

interface Props {
  pkg: Package;
}

export function TripBreakdown({ pkg }: Props) {
  return (
    <dl className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
      <dt className="text-slate-500">Ticket</dt>
      <dd className="text-right font-medium">{formatCents(pkg.ticket_cents)}</dd>

      <dt className="text-slate-500">Flight</dt>
      <dd className="text-right font-medium">{formatCents(pkg.flight_cents)}</dd>

      <dt className="text-slate-500">Hotel (2 nights)</dt>
      <dd className="text-right font-medium">{formatCents(pkg.hotel_cents)}</dd>

      <dt className="border-t border-slate-300 pt-2 font-semibold text-slate-900">
        Total
      </dt>
      <dd className="border-t border-slate-300 pt-2 text-right text-base font-bold text-brand-700">
        {formatCents(pkg.total_cents)}
      </dd>
    </dl>
  );
}
